module.exports = __webpack_public_path__ + "static/media/compareDemographicsImg.f0cf7a5a.svg";